module.exports = __webpack_public_path__ + "img/expand.ca65d2bb.svg";